let browseSvg = 
  `
    <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `
  
  let giveSvg = 
  `
  <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `

  let down_caret = 
  `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><polygon points="50 77.1 2.15 28.51 7.85 22.9 50 65.7 92.15 22.9 97.85 28.51 50 77.1"></polygon></g></svg>
  `

  //FAQ下拉菜单
  let menuFaqList = [
    {
      categoryId:'Headphones',
      categoryName: 'Headphones',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'X Series',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Over Ear Series',
          productList:[
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            {
              productId: 'TOZO_H10',
              productName: 'TOZO H10',
            },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Open Series',
          productList:[
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_OpenEarRing',
              productName: 'TOZO OpenEarRing',
            }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'T Series',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Tonal Series',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_T6S',
              productName: 'TOZO T6S',
            },
            {
              productId: 'TOZO_T10S',
              productName: 'TOZO T10S',
            },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'NC Series',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            {
              productId: 'TOZO_NC9_Plus',
              productName: 'TOZO NC9 Plus',
            },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: ' TOZO_Cryatl_Pods',
              productName: ' TOZO Cryatl Pods',
            },
          ]
        },
        {
          seriesId: 'NC_Pro_Series',
          seriesName: 'NC Pro Series',
          productList:[
            {
              productId: 'TOZO_NC2_Pro',
              productName: 'TOZO NC2 Pro',
            },
            {
              productId: 'TOZO_NC7_Pro',
              productName: 'TOZO NC7 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro',
              productName: 'TOZO NC9 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro_Max',
              productName: 'TOZO NC9 Pro Max',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
          ]
        },
        {
          seriesId: 'A_Series',
          seriesName: 'A Series',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'Agile_Series',
          seriesName: 'Agile Series',
          productList:[
            {
              productId: 'TOZO_Agile_Pods',
              productName: 'TOZO Agile Pods',
            },
            {
              productId: 'TOZO_Agile_Dots',
              productName: 'TOZO Agile Dots',
            },
          ]
        },
        {
          seriesId: 'E_Series',
          seriesName: 'E Series',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
        {
          seriesId: 'G_Series',
          seriesName: 'G Series',
          productList:[
            {
              productId: 'TOZO_G1',
              productName: 'TOZO G1',
            },
            {
              productId: 'TOZO_Gaming_Pods',
              productName: 'TOZO Gaming Pods',
            },
          ]
        },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Watches',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Watches',
          productList:[
            {
              productId: 'TOZO_S1',
              productName: 'TOZO S1',
            },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            {
              productId: 'TOZO_S3',
              productName: 'TOZO S3',
            },
            {
              productId: 'TOZO_S4',
              productName: 'TOZO S4',
            },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Speakers',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Speakers',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'Panoramic Camera',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'Smart audio and video',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'Wireless Charging',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'Wireless Charger',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            {
              productId: 'TOZO_WB1',
              productName: 'TOZO WB1',
            },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            {
              productId: 'TOZO_W8',
              productName: 'TOZO W8',
            },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
        //   ]
        // }
      ]
    },
    {
      categoryId: 'Charger',
      categoryName: 'Charger',
      seriesList:[
        {
          seriesId: 'Wall_Chargers',
          seriesName: 'Wall Chargers',
          productList:[
            {
              productId: 'TOZO_C1',
              productName: 'TOZO C1',
            },
            {
              productId: 'TOZO_C2',
              productName: 'TOZO C2',
            },
          ]
        },
        {
          seriesId: 'Power_Banks',
          seriesName: 'Power Banks',
          productList:[
            {
              productId: 'TOZO_PB1',
              productName: 'TOZO PB1',
            },
            {
              productId: 'TOZO_PB2',
              productName: 'TOZO PB2',
            },
            {
              productId: 'TOZO_PB3',
              productName: 'TOZO PB3',
            },
          ]
        },
      ]
    },
  ]

  //Manuals下拉菜单
  let menuManualsList = [
    {
      categoryId:1,
      categoryName: 'Headphones',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'X Series',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
            {
              productId: 'TOZO_Color_Pods',
              productName: 'TOZO Color Pods',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Over Ear Series',
          productList:[
            {
              productId: 'TOZO_HA1',
              productName: 'TOZO HA1',
            },
            {
              productId: 'TOZO_HT1',
              productName: 'TOZO HT1',
            },
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            // {
            //   productId: 'TOZO_H10',
            //   productName: 'TOZO H10',
            // },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Open Series',
          productList:[
            {
              productId: 'TOZO_Open_X2_Pro',
              productName: 'TOZO Open X2 Pro',
            },
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_Open_EarRing',
              productName: 'TOZO Open EarRing',
            },
            {
              productId: 'TOZO_O2',
              productName: 'TOZO O2',
            },
            // {
            //   productId: 'TOZO_OpenWear',
            //   productName: 'TOZO OpenWear',
            // }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'T Series',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Tonal Series',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_Tonal_Fits',
              productName: 'TOZO Tonal Fits',
            },
            // {
            //   productId: 'TOZO_T6S',
            //   productName: 'TOZO T6S',
            // },
            // {
            //   productId: 'TOZO_T10S',
            //   productName: 'TOZO T10S',
            // },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'NC Series',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            // {
            //   productId: 'TOZO_NC9_Plus',
            //   productName: 'TOZO NC9 Plus',
            // },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
            {
              productId: 'TOZO_Crystal_Pods',
              productName: 'TOZO Crystal Pods',
            },
          ]
        },
        // {
        //   seriesId: 'NC_Pro_Series',
        //   seriesName: 'NC Pro Series',
        //   productList:[
        //     {
        //       productId: 'TOZO_NC2_Pro',
        //       productName: 'TOZO NC2 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC7_Pro',
        //       productName: 'TOZO NC7 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro',
        //       productName: 'TOZO NC9 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro_Max',
        //       productName: 'TOZO NC9 Pro Max',
        //     },
        //   ]
        // },
        {
          seriesId: 'A_Series',
          seriesName: 'A Series',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        // {
        //   seriesId: 'Agile_Series',
        //   seriesName: 'Agile Series',
        //   productList:[
        //     {
        //       productId: 'TOZO_Agile_Pods',
        //       productName: 'TOZO Agile Pods',
        //     },
        //     {
        //       productId: 'TOZO_Agile_Dots',
        //       productName: 'TOZO Agile Dots',
        //     },
        //   ]
        // },
        // {
        //   seriesId: 'G_Series',
        //   seriesName: 'G Series',
        //   productList:[
        //     {
        //       productId: 'TOZO_G1',
        //       productName: 'TOZO G1',
        //     },
        //     {
        //       productId: 'TOZO_Gaming_Pods',
        //       productName: 'TOZO Gaming Pods',
        //     },
        //   ]
        // },
        {
          seriesId: 'E_Series',
          seriesName: 'E Series',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Watches',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Watches',
          productList:[
            {
              productId: 'TOZO_Watch1',
              productName: 'TOZO Watch1',
            },
            // {
            //   productId: 'TOZO_S1',
            //   productName: 'TOZO S1',
            // },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            // {
            //   productId: 'TOZO_S3',
            //   productName: 'TOZO S3',
            // },
            // {
            //   productId: 'TOZO_S4',
            //   productName: 'TOZO S4',
            // },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
            {
              productId: 'TOZO_S7',
              productName: 'TOZO S7',
            },
            {
              productId: 'TOZO_S8',
              productName: 'TOZO S8',
            },
            {
              productId: 'TOZO_AcuFit_Solo',
              productName: 'TOZO AcuFit Solo',
            },
            {
              productId: 'TOZO_AcuFit_Evo',
              productName: 'TOZO AcuFit Evo',
            },
          ]
    //     }
    //   ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Speakers',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Speakers',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
            {
              productId: 'TOZO_PE1',
              productName: 'TOZO PE1',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Panoramic_Camera',
    //   categoryName: 'Panoramic Camera',
    //   seriesList:[
    //     {
    //       seriesId: 'Smart_audio_and_video',
    //       seriesName: 'Smart audio and video',
    //       productList:[
    //         {
    //           productId: 'AnyVue',
    //           productName: 'AnyVue',
    //         },
    //       ]
    //     }
    //   ]
    // },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'Wireless Charging',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'Wireless Charger',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            // {
            //   productId: 'TOZO_WB1',
            //   productName: 'TOZO WB1',
            // },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            // {
            //   productId: 'TOZO_W8',
            //   productName: 'TOZO W8',
            // },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Charger',
    //   categoryName: 'Charger',
    //   seriesList:[
    //     {
    //       seriesId: 'Wall_Chargers',
    //       seriesName: 'Wall Chargers',
    //       productList:[
    //         {
    //           productId: 'TOZO_C1',
    //           productName: 'TOZO C1',
    //         },
    //         {
    //           productId: 'TOZO_C2',
    //           productName: 'TOZO C2',
    //         },
    //       ]
    //     },
    //     {
    //       seriesId: 'Power_Banks',
    //       seriesName: 'Power Banks',
    //       productList:[
    //         {
    //           productId: 'TOZO_PB1',
    //           productName: 'TOZO PB1',
    //         },
    //         {
    //           productId: 'TOZO_PB2',
    //           productName: 'TOZO PB2',
    //         },
    //         {
    //           productId: 'TOZO_PB3',
    //           productName: 'TOZO PB3',
    //         },
    //       ]
    //     },
    //   ]
    // },
  ]

  //Video下拉菜单
  let menuVideoList = [
    {
      categoryId:1,
      categoryName: 'Headphones',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'X Series',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Over Ear Series',
          productList:[
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            {
              productId: 'TOZO_H10',
              productName: 'TOZO H10',
            },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Open Series',
          productList:[
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'T Series',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            // {
            //   productId: 'TOZO_T6_Mini',
            //   productName: 'TOZO T6 Mini',
            // },
            // {
            //   productId: 'TOZO_T9',
            //   productName: 'TOZO T9',
            // },
            // {
            //   productId: 'TOZO_T10',
            //   productName: 'TOZO T10',
            // },
            // {
            //   productId: 'TOZO_T10_Mini',
            //   productName: 'TOZO T10 Mini',
            // },
            // {
            //   productId: 'TOZO_T12',
            //   productName: 'TOZO T12',
            // },
            // {
            //   productId: 'TOZO_T12_Pro',
            //   productName: 'TOZO T12 Pro',
            // },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            // {
            //   productId: 'TOZO_T21',
            //   productName: 'TOZO T21',
            // },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Tonal Series',
          productList:[
            {
              productId: 'TOZO_Tonal_Pots',
              productName: 'TOZO Tonal Pots',
            },
            {
              productId: 'TOZO_Tonal_Fits',
              productName: 'TOZO Tonal Fits',
            },
            {
              productId: 'TOZO_T6S',
              productName: 'TOZO T6S',
            },
            {
              productId: 'TOZO_T10S',
              productName: 'TOZO T10S',
            },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'NC Series',
          productList:[
            // {
            //   productId: 'TOZO_NC2',
            //   productName: 'TOZO NC2',
            // },
            // {
            //   productId: 'TOZO_NC7',
            //   productName: 'TOZO NC7',
            // },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            // {
            //   productId: 'TOZO_NC9_Plus',
            //   productName: 'TOZO NC9 Plus',
            // },
          ]
        },
        {
          seriesId: 'NC_Pro_Series',
          seriesName: 'NC Pro Series',
          productList:[
            // {
            //   productId: 'TOZO_NC2_Pro',
            //   productName: 'TOZO NC2 Pro',
            // },
            {
              productId: 'TOZO_NC7_Pro',
              productName: 'TOZO NC7 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro',
              productName: 'TOZO NC9 Pro',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
            // {
            //   productId: 'TOZO_NC9_Pro_Max',
            //   productName: 'TOZO NC9 Pro Max',
            // },
          ]
        },
        {
          seriesId: 'A_Series',
          seriesName: 'A Series',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            // {
            //   productId: 'TOZO_A2',
            //   productName: 'TOZO A2',
            // },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'Agile_Series',
          seriesName: 'Agile Series',
          productList:[
            {
              productId: 'TOZO_Agile_Pods',
              productName: 'TOZO Agile Pods',
            },
            {
              productId: 'TOZO_Agile_Dots',
              productName: 'TOZO Agile Dots',
            },
          ]
        },
        // {
        //   seriesId: 'G_Series',
        //   seriesName: 'G Series',
        //   productList:[
        //     {
        //       productId: 'TOZO_G1',
        //       productName: 'TOZO G1',
        //     },
        //     {
        //       productId: 'TOZO_Gaming_Pods',
        //       productName: 'TOZO Gaming Pods',
        //     },
        //   ]
        // },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Watches',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Watches',
          productList:[
            // {
            //   productId: 'TOZO_S1',
            //   productName: 'TOZO S1',
            // },
            // {
            //   productId: 'TOZO_S2',
            //   productName: 'TOZO S2',
            // },
            // {
            //   productId: 'TOZO_S3',
            //   productName: 'TOZO S3',
            // },
            // {
            //   productId: 'TOZO_S4',
            //   productName: 'TOZO S4',
            // },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
            {
              productId: 'TOZO_S6',
              productName: 'TOZO S6',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Speakers',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Speakers',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            // {
            //   productId: 'TOZO_PA2',
            //   productName: 'TOZO PA2',
            // },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'Panoramic Camera',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'Smart audio and video',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Wireless_Charging',
    //   categoryName: 'Wireless Charging',
    //   seriesList:[
    //     {
    //       seriesId: 'Wireless_Charger',
    //       seriesName: 'Wireless Charger',
    //       productList:[
    //         {
    //           productId: 'TOZO_W1',
    //           productName: 'TOZO W1',
    //         },
    //         {
    //           productId: 'TOZO_WB1',
    //           productName: 'TOZO WB1',
    //         },
    //         {
    //           productId: 'TOZO_W6',
    //           productName: 'TOZO W6',
    //         },
    //         {
    //           productId: 'TOZO_W8',
    //           productName: 'TOZO W8',
    //         },
    //         {
    //           productId: 'TOZO_W10',
    //           productName: 'TOZO W10',
    //         },
    //       ]
    //     }
    //   ]
    // },
    // {
    //   categoryId: 'Charger',
    //   categoryName: 'Charger',
    //   seriesList:[
    //     {
    //       seriesId: 'Wall_Chargers',
    //       seriesName: 'Wall Chargers',
    //       productList:[
    //         {
    //           productId: 'TOZO_C1',
    //           productName: 'TOZO C1',
    //         },
    //         {
    //           productId: 'TOZO_C2',
    //           productName: 'TOZO C2',
    //         },
    //       ]
    //     },
    //     {
    //       seriesId: 'Power_Banks',
    //       seriesName: 'Power Banks',
    //       productList:[
    //         {
    //           productId: 'TOZO_PB1',
    //           productName: 'TOZO PB1',
    //         },
    //         {
    //           productId: 'TOZO_PB2',
    //           productName: 'TOZO PB2',
    //         },
    //         {
    //           productId: 'TOZO_PB3',
    //           productName: 'TOZO PB3',
    //         },
    //       ]
    //     },
    //   ]
    // },
  ]

  //FAQ资源
  let faqList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //故障资源
  let TrobuleshootingList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //视频资源
  let videoHttps = 'https://s3-us-tozo-production.tozostore.com/support/video/'
  let language = 'EN'
  let VideoTutoralList = [
    //X系列
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    //H系列
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    {
      id:3,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      title: 'TOZO H10',
      url: `${videoHttps}H10_${language}.mp4`,
    },
    //Open系列
    {
      id:4,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title: 'TOZO OpenBuds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    //T系列
    {
      id:7,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_T6S',
      productName: 'TOZO T6S',
      title: 'TOZO T6S',
      url: `${videoHttps}T6S_${language}.mov`,
    },
    {
      id:9,
      productId: 'TOZO_T10S',
      productName: 'TOZO T10S',
      title: 'TOZO T10S',
      url: `${videoHttps}T10S_${language}.mp4`,
    },
    {
      id:10,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title: 'TOZO Crystal Buds',
      url: `${videoHttps}T18_${language}.mp4`,
    },
    {
      id:11,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title: 'TOZO T20',
      url: `${videoHttps}T20_${language}.mp4`,
    },
    //Tonal系列
    {
      id:12,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title: 'TOZO Tonal Fits',
      url: `${videoHttps}Tonal_Fits_${language}.mp4`,
    },
    {
      id:13,
      productId: 'TOZO_Tonal_Pots',
      productName: 'TOZO Tonal Pods',
      title: 'TOZO Tonal Pods',
      url: `${videoHttps}Tonal_Pods_${language}.mp4`,
    },
    //A系列
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:15,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title: 'TOZO A3',
      url: `${videoHttps}A3_${language}.mp4`,
    },
    //Agile系列
    {
      id:16,
      productId: 'TOZO_Agile_Dots',
      productName: 'TOZO Agile Dots',
      title: 'TOZO Agile Dots',
      url: `${videoHttps}Agile_Dots_${language}.mov`,
    },
    {
      id:17,
      productId: 'TOZO_Agile_Pods',
      productName: 'TOZO Agile Pods',
      title: 'TOZO Agile Pods',
      url: `${videoHttps}Agile_Pods_${language}.mov`,
    },
    //NC系列
    {
      id:18,
      productId: 'TOZO_NC7_Pro',
      productName: 'TOZO NC7 Pro',
      title: 'TOZO NC7 Pro',
      url: `${videoHttps}NC7_Pro${language}.mp4`,
    },
    {
      id:19,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9 reset',
      url: `${videoHttps}NC9_${language}.mp4`,
    },
    {
      id:20,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9 cleaning and reintall eartips',
      url: `${videoHttps}NC9_2_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC9_Pro',
      productName: 'TOZO NC9 Pro',
      title: 'TOZO NC9 Pro',
      url: `${videoHttps}NC9_Pro_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title: 'TOZO NC20 Pro',
      url: `${videoHttps}NC20_Pro_${language}.mp4`,
    },

    //S系列 手表
    {
      id:22,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
    {
      id:23,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'TOZO S6 smart watch unboxing video',
      url: `${videoHttps}S6_${language}.mp4`,
    },
    {
      id:24,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'TOZO S6 watch band installation video guide ',
      url: `${videoHttps}S6_watch_band_installation_video_guide_${language}.mp4`,
    },

    //P系列 音箱
    {
      id:25,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title: 'TOZO PA1',
      url: `${videoHttps}PA1_${language}.mp4`,
    },

    //Panoramic Camera系列 相机
    {
      id:26,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue quick sharing tutorial',
      url: `${videoHttps}AnyVue_quick_sharing_tutorial_${language}.mp4`,
    },
    {
      id:27,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue teaching video AI dictation modification 2',
      url: `${videoHttps}AnyVue_teaching_video_AI_dictation_modification_2_${language}.mp4`,
    },
    {
      id:28,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue link VinsionPro operation',
      url: `${videoHttps}AnyVue_link_VinsionPro_operation_${language}.mp4`,
    },
    {
      id:29,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue YouTube live broadcast enAI dictation modification',
      url: `${videoHttps}AnyVue_YouTube_live_broadcast_enAI_dictation_modification_${language}.mp4`,
    },
    {
      id:30,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue film pasting video AI oral modification',
      url: `${videoHttps}AnyVue_film_pasting_video_AI_oral_modification_${language}.mp4`,
    },
  ]

  //说明书资源
  let TOZO_pdf_https = 'https://s3-us.tozostore.com/tozo/pdfRenderer/web/'
  let Anybuds_pdf_https = 'https://s3-prod.anybuds.com/pdfRenderer/web/'
  let UserManual = 'UserManual'
  let QuickGuide = 'QuickGuide'

  let TOZO = 'TOZO'
  let Anybuds = 'Anybuds'

  // TOZO
  let preview_TOZO_UserManual_Url = `${TOZO_pdf_https}index.html?file=docs/${UserManual}/${TOZO}/`//预览用户指南
  let download_TOZO_UserManual_Url = `${TOZO_pdf_https}docs/${UserManual}/${TOZO}/` //下载用户指南

  let preview_TOZO_QuickGuide_Url = `${TOZO_pdf_https}index.html?file=docs/${QuickGuide}/${TOZO}/`//预览快速指引
  let download_TOZO_QuickGuide_Url = `${TOZO_pdf_https}docs/${QuickGuide}/${TOZO}/` //下载快速指引

  // Anybuds
  let preview_Anybuds_UserManual_Url = `${Anybuds_pdf_https}index.html?file=docs/${UserManual}/${Anybuds}/`//预览用户指南
  let download_Anybuds_UserManual_Url = `${Anybuds_pdf_https}docs/${UserManual}/${Anybuds}/` //下载用户指南

  let preview_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}index.html?file=docs/${QuickGuide}/${Anybuds}/`//预览快速指引
  let download_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}docs/${QuickGuide}/${Anybuds}/` //下载快速指引
  
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/docs/QuickGuide/TOZO/T6.pdf
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/index.html?file=docs/UserManual/TOZO/T6.pdf
  // https://s3-prod.anybuds.com/pdfRenderer/web/index.html?file=docs/UserManual/Anybuds/Clips.pdf
  let manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },
    
    {
      id:3,
      productId: 'TOZO_Color_Pods',
      productName: 'TOZO Color Pods',
      title:'TOZO Color Pods User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Color_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Color_Pods.pdf`,
    },
    // {
    //   id:4,
    //   productId: 'TOZO_Color_Pods',
    //   productName: 'TOZO Color Pods',
    //   title:'TOZO Color Pods Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    // },

    {
      id:5,
      productId: 'TOZO_HA1',
      productName: 'TOZO HA1',
      title:'TOZO HA1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HA1.pdf`,
    },
    // {
    //   id:6,
    //   productId: 'TOZO_HA1',
    //   productName: 'TOZO HA1',
    //   title:'TOZO HA1 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HA1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HA1.pdf`,
    // },

    // {
    //   id:7,
    //   productId: 'TOZO_HT1',
    //   productName: 'TOZO HT1',
    //   title:'TOZO HA1 User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}HT1.pdf`,
    // },
    {
      id:8,
      productId: 'TOZO_HT1',
      productName: 'TOZO HT1',
      title:'TOZO HT1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT1.pdf`,
    },
    

    {
      id:9,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_Open_X2_Pro',
      productName: 'TOZO Open X2 Pro',
      title:'TOZO Open X2 Pro User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
    },
    // {
    //   id:12,
    //   productId: 'TOZO_Open_X2_Pro',
    //   productName: 'TOZO Open X2 Pro',
    //   title:'TOZO Open X2 Pro Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    // },

    {
      id:11,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },

    {
      id:17,
      productId: 'TOZO_Open_EarRing',
      productName: 'TOZO Open EarRing',
      title:'TOZO Open EarRing User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing.pdf`,
    },
    // {
    //   id:18,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    // },

    // {
    //   id:19,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    // },
    // {
    //   id:20,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    // },

    {
      id:21,
      productId: 'TOZO_O2',
      productName: 'TOZO O2',
      title:'TOZO O2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}O2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}O2.pdf`,
    },
    // {
    //   id:22,
    //   productId: 'TOZO_O2',
    //   productName: 'TOZO O2',
    //   title:'TOZO O2 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}O2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}O2.pdf`,
    // },

    // {
    //   id:23,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}OpenWear.pdf`,
    // },
    // {
    //   id:24,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}OpenWear.pdf`,
    // },

    {
      id:25,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:26,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:27,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini.pdf`,
    },
    {
      id:28,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini.pdf`,
    },

    // {
    //   id:29,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    // },
    // {
    //   id:30,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    // },

    {
      id:30,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10.pdf`,
    },
    {
      id:32,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10.pdf`,
    },

    {
      id:33,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini.pdf`,
    },
    {
      id:34,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini.pdf`,
    },

    // {
    //   id:35,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    // },
    // {
    //   id:36,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    // },

    {
      id:37,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T9.pdf`,
    },
    {
      id:38,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T9.pdf`,
    },

    {
      id:39,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12.pdf`,
    },
    {
      id:40,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12.pdf`,
    },

    {
      id:41,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12_Pro.pdf`,
    },
    {
      id:42,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12_Pro.pdf`,
    },

    {
      id:43,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T20.pdf`,
    },
    {
      id:44,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T20.pdf`,
    },

    {
      id:45,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T21.pdf`,
    },
    {
      id:46,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T21.pdf`,
    },

    {
      id:47,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Dots.pdf`,
    },
    {
      id:48,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
    },

    {
      id:49,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Fits.pdf`,
    },
    {
      id:50,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
    },

    {
      id:51,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Buds.pdf`,
    },
    {
      id:52,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
    },

    {
      id:53,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC2.pdf`,
    },
    {
      id:54,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC2.pdf`,
    },

    {
      id:55,
      productId: 'TOZO_NC3',
      productName: 'TOZO NC3',
      title:'TOZO NC3 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3.pdf`,
    },
    // {
    //   id:56,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3.pdf`,
    // },

    // {
    //   id:57,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    // },
    // {
    //   id:58,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    // },

    {
      id:59,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC7.pdf`,
    },
    {
      id:60,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC7.pdf`,
    },

    {
      id:61,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (New T11124)  User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9_new.pdf`,
    },
    // {
    //   id:62,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9_new.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (Old) User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9.pdf`,
    },
    {
      id:64,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (Old) Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9.pdf`,
    },

    //添加霍尔开关版本
    // {
    //   id:65,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New2)  User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9-0xCD.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9-0xCD.pdf`,
    // },
    // {
    //   id:66,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New2) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9-0xCD.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9-0xCD.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20',
      productName: 'TOZO NC20',
      title:'TOZO NC20 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20',
    //   productName: 'TOZO NC20',
    //   title:'TOZO NC20 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title:'TOZO NC20 Pro User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20_Pro.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20_Pro',
    //   productName: 'TOZO NC20 Pro',
    //   title:'TOZO NC20 Pro Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    // },

    {
      id:67,
      productId: 'TOZO_Crystal_Pods',
      productName: 'TOZO Crystal Pods',
      title:'TOZO Crystal Pods User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Pods.pdf`,
    },
    // {
    //   id:68,
    //   productId: 'TOZO_Crystal_Pods',
    //   productName: 'TOZO Crystal Pods',
    //   title:'TOZO Crystal Pods Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    // },

    {
      id:69,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 (New) User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1_new.pdf`,
    },
    // {
    //   id:70,
    //   productId: 'TOZO_A1',
    //   productName: 'TOZO A1',
    //   title:'TOZO A1 (New) Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1_new.pdf`,
    // },

    {
      id:71,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:72,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:73,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A2.pdf`,
    },
    {
      id:74,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A2.pdf`,
    },

    {
      id:75,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3.pdf`,
    },
    {
      id:76,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A3.pdf`,
    },

    //支持app
    {
      id:77,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 User Manual (Support APP)',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3_APP.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3_APP.pdf`,
    },

    {
      id:78,
      productId: 'TOZO_E1',
      productName: 'TOZO E1',
      title:'TOZO E1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E1.pdf`,
    },
    // {
    //   id:79,
    //   productId: 'TOZO_E1',
    //   productName: 'TOZO E1',
    //   title:'TOZO E1 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E1.pdf`,
    // },

    {
      id:80,
      productId: 'TOZO_E2',
      productName: 'TOZO E2',
      title:'TOZO E2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E2.pdf`,
    },
    // {
    //   id:81,
    //   productId: 'TOZO_E2',
    //   productName: 'TOZO E2',
    //   title:'TOZO E2 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E2.pdf`,
    // },

    {
      id:82,
      productId: 'TOZO_Watch1',
      productName: 'TOZO Watch1',
      title:'TOZO Watch1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Watch1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Watch1.pdf`,
    },
    // {
    //   id:83,
    //   productId: 'TOZO_Watch1',
    //   productName: 'TOZO Watch1',
    //   title:'TOZO Watch1 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Watch1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Watch1.pdf`,
    // },

    {
      id:84,
      productId: 'TOZO_S2',
      productName: 'TOZO S2',
      title:'TOZO S2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S2.pdf`,
    },
    // {
    //   id:85,
    //   productId: 'TOZO_S2',
    //   productName: 'TOZO S2',
    //   title:'TOZO S2 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S2.pdf`,
    // },

    // {
    //   id:86,
    //   productId: 'TOZO_S3',
    //   productName: 'TOZO S3',
    //   title:'TOZO S3 User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S3.pdf`,
    // },
    // {
    //   id:87,
    //   productId: 'TOZO_S3',
    //   productName: 'TOZO S3',
    //   title:'TOZO S3 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S3.pdf`,
    // },

    // {
    //   id:88,
    //   productId: 'TOZO_S4',
    //   productName: 'TOZO S4',
    //   title:'TOZO S4 User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S4.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S4.pdf`,
    // },
    // {
    //   id:89,
    //   productId: 'TOZO_S4',
    //   productName: 'TOZO S4',
    //   title:'TOZO S4 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S4.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S4.pdf`,
    // },

    {
      id:90,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    // {
    //   id:91,
    //   productId: 'TOZO_S5',
    //   productName: 'TOZO S5',
    //   title:'TOZO S5 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    // },

    // {
    //   id:92,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 User Manual',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S6.pdf`,
    // },
    // {
    //   id:93,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S6.pdf`,
    // },

    {
      id:94,
      productId: 'TOZO_S7',
      productName: 'TOZO S7',
      title:'TOZO S7 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S7.pdf`,
    },
    // {
    //   id:95,
    //   productId: 'TOZO_S7',
    //   productName: 'TOZO S7',
    //   title:'TOZO S7 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S7.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S7.pdf`,
    // },

    {
      id:96,
      productId: 'TOZO_S8',
      productName: 'TOZO S8',
      title:'TOZO S8 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S8.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S8.pdf`,
    },
    // {
    //   id:97,
    //   productId: 'TOZO_S8',
    //   productName: 'TOZO S8',
    //   title:'TOZO S8 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S8.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S8.pdf`,
    // },

    {
      id:98,
      productId: 'TOZO_AcuFit_Lite',
      productName: 'TOZO AcuFit Lite',
      title:'TOZO AcuFit Lite User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
    },
    // {
    //   id:99,
    //   productId: 'TOZO_AcuFit_Lite',
    //   productName: 'TOZO AcuFit Lite',
    //   title:'TOZO AcuFit Lite Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    // },

    {
      id:100,
      productId: 'TOZO_AcuFit_One',
      productName: 'TOZO AcuFit One',
      title:'TOZO AcuFit One User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_One.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_One.pdf`,
    },
    // {
    //   id:101,
    //   productId: 'TOZO_AcuFit_One',
    //   productName: 'TOZO AcuFit One',
    //   title:'TOZO AcuFit One Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_One.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_One.pdf`,
    // },

    {
      id:102,
      productId: 'TOZO_AcuFit_GT',
      productName: 'TOZO AcuFit GT',
      title:'TOZO AcuFit GT User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_GT.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_GT.pdf`,
    },
    // {
    //   id:103,
    //   productId: 'TOZO_AcuFit_GT',
    //   productName: 'TOZO AcuFit GT',
    //   title:'TOZO AcuFit GT Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    // },
    

    {
      id:104,
      productId: 'TOZO_AcuFit_Solo',
      productName: 'TOZO AcuFit Solo',
      title:'TOZO AcuFit Solo User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
    },
    // {
    //   id:105,
    //   productId: 'TOZO_AcuFit_Solo',
    //   productName: 'TOZO AcuFit_Solo',
    //   title:'TOZO AcuFit Solo Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    // },

    {
      id:106,
      productId: 'TOZO_AcuFit_Evo',
      productName: 'TOZO AcuFit Evo',
      title:'TOZO AcuFit Evo User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
    },
    // {
    //   id:107,
    //   productId: 'TOZO_AcuFit_Evo',
    //   productName: 'TOZO AcuFit Evo',
    //   title:'TOZO AcuFit Evo Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    // },

    {
      id:108,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PA1.pdf`,
    },
    {
      id:109,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PA1.pdf`,
    },

    {
      id:110,
      productId: 'TOZO_PA2',
      productName: 'TOZO PA2',
      title:'TOZO PA2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PA2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PA2.pdf`,
    },
    // {
    //   id:112,
    //   productId: 'TOZO_PA2',
    //   productName: 'TOZO PA2',
    //   title:'TOZO PA2 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PA2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PA2.pdf`,
    // },

    {
      id:113,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PE1.pdf`,
    },
    {
      id:114,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PE1.pdf`,
    },

    {
      id:115,
      productId: 'TOZO_W1',
      productName: 'TOZO W1',
      title:'TOZO W1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W1.pdf`,
    },
    // {
    //   id:116,
    //   productId: 'TOZO_W1',
    //   productName: 'TOZO W1',
    //   title:'TOZO W1 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W1.pdf`,
    // },

    {
      id:117,
      productId: 'TOZO_W6',
      productName: 'TOZO W6',
      title:'TOZO W6 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W6.pdf`,
    },
    // {
    //   id:118,
    //   productId: 'TOZO_W6',
    //   productName: 'TOZO W6',
    //   title:'TOZO W6 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W6.pdf`,
    // },

    {
      id:119,
      productId: 'TOZO_W10',
      productName: 'TOZO W10',
      title:'TOZO W10 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W10.pdf`,
    },
    // {
    //   id:120,
    //   productId: 'TOZO_W10',
    //   productName: 'TOZO W10',
    //   title:'TOZO W10 Quick Guide',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W10.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W10.pdf`,
    // },


    // Anybuds
    // {
    //   id:121,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips User Manual',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Clips.pdf`,
    // },
    // {
    //   id:122,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips Quick Guide',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Clips.pdf`,
    // },

    // {
    //   id:123,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots User Manual',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Dots.pdf`,
    // },
    // {
    //   id:124,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots Quick Guide',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Dots.pdf`,
    // },

    // // {
    // //   id:125,
    // //   productId: 'Anybuds_Fits',
    // //   productName: 'Anybuds Fits',
    // //   title:'Anybuds Fits User Manual',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Fits.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Fits.pdf`,
    // // },
    // {
    //   id:126,
    //   productId: 'Anybuds_Fits',
    //   productName: 'Anybuds Fits',
    //   title:'Anybuds Fits Quick Guide',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Fits.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Fits.pdf`,
    // },

    // // {
    // //   id:127,
    // //   productId: 'Anybuds_Pro',
    // //   productName: 'Anybuds Pro',
    // //   title:'Anybuds Pro User Manual',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Pro.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Pro.pdf`,
    // // },
    // {
    //   id:128,
    //   productId: 'Anybuds_Pro',
    //   productName: 'Anybuds Pro',
    //   title:'Anybuds Pro Quick Guide',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Pro.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Pro.pdf`,
    // },

    // {
    //   id:129,
    //   productId: 'Anybuds_Vivid',
    //   productName: 'Anybuds Vivid',
    //   title:'Anybuds Vivid User Manual',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Vivid.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Vivid.pdf`,
    // },
    // // {
    // //   id:130,
    // //   productId: 'Anybuds_Vivid',
    // //   productName: 'Anybuds Vivid',
    // //   title:'Anybuds Vivid Quick Guide',
    // //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // // },

  ]
  
  //热门FAQ资源
  let hot_faqList = [
    {
      know_id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'Why the earbuds does not hold a charge?',
      description: `
      Check if the metal connector is dirty, try to wipe it softly with dry cloth, paperclip or paper towels. 
      (sweat or humidity may also lead to disconnection ) <br/>
      2.Please have the battery case fully charged at the beginning without putting the earbuds in. <br/>
      ·Swap the left and right earbuds to charge for a try. <br/>
      ·Put the left one in the right side of the case, so does the right earphone, which is put in the left side of the case. <br/>
      ·Confirm whether it’s the issue of battery case after operating steps above.   <br/> 
      3.Reset could solve many problems occurred. <br/>
      `
    },
    {
      know_id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'How to adjust the volume by earbuds?',
      description: `
      Long press L or R earbud to adjust the volume while playing music. <br/>
      R earbud Volume + <br/>
      L earbud Volume - <br/>
      The volume adjustment is not available when it's connected to a TV and computer. <br/>
      `
    },
    {
      know_id:3,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'What should I do if the computer says they need a driver or transmitter to connect the earbuds?',
      description: `
      Here are some methods for your reference. <br/>
      ·Download a Bluetooth receiver to connect(in the computer settings) <br/>
      ·Kindly check if your computer’s Bluetooth version supports Bluetooth 5.0 <br/>
      `
    },
    {
      know_id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: 'What are the key features of the TOZO HT2 Headphones?',
      description: `
      The TOZO HT2 offers adaptive hybrid active noise cancelling, 40mm dynamic driver units, Hi-Res Audio Certification, and 3-MIC ENC call noise cancelling.
      `
    },
    {
      know_id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'What makes the TOZO Open Buds unique?',
      description: `
      The TOZO Open Buds feature an innovative biaxial rotation design for customizable comfort and 
      an open-ear design that allows you to stay aware of your surroundings.
      `
    },
    {
      know_id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'How is the sound quality of the TOZO Open Buds?',
      description: `
      The 14.2mm large dynamic driver units deliver clear, high-quality sound with powerful bass.
      `
    },
    {
      know_id:7,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'Are the TOZO Open Buds comfortable to wear?',
      description: `
      Yes, the biaxial rotation design allows for multi-angle adjustment, providing ultimate comfort during extended use.
      `
    },
    {
      know_id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'What are the key features of the TOZO OpenReal earbuds?',
      description: `
      The TOZO OpenReal features an open-ear design, air conduction technology, 
      Bluetooth 5.3, dual-mic ENC for call noise cancellation, 
      and 16.2mm dynamic drivers for clear and powerful sound.
      `
    },
    {
      know_id:9,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'How is the sound quality of the TOZO OpenReal earbuds?',
      description: `
      The 16.2mm dynamic drivers provide beautiful sound with clear highs and powerful bass.
      `
    },
    {
      know_id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'What are the main features of the TOZO OpenEgo headphones?',
      description: `
      The TOZO OpenEgo features an open-ear design for comfort, air conduction technology for clear music, 
      Bluetooth 5.3 for a stable connection, dual-mic DNS for call noise cancellation, and 16.2mm dynamic drivers for high-quality sound.
      `
    },
    {
      know_id:11,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'What noise cancellation features do the TOZO OpenEgo headphones have?',
      description: `
      They feature dual-mic DNS (Digital Noise Suppression) technology for clear calls by minimizing background noise.
      `
    },
    {
      know_id:12,
      productId: 'TOZO_PA2',
      productName: 'TOZO PA2',
      browse: '',
      give: '',
      title: 'What are the main features of the TOZO PA2 Bluetooth Speaker?',
      description: `
      The TOZO PA2 offers immersive stereo sound, three EQ modes, 25-hour playtime, IPX8 waterproofing, and Bluetooth calling.
      `
    },
    {
      know_id:13,
      productId: 'TOZO_S1',
      productName: 'TOZO S1',
      browse: '',
      give: '',
      title: 'Is this watch waterproof?',
      description: `
      Yes, this watch is waterproof and suitable for everyday use, but it is recommended to avoid prolonged immersion in water.
      `
    },
  ]

  //热门故障资源
  let hot_TrobuleshootingList = [
    {
      know_id:1,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: 'How to reset TOZO HT2?',
      description: `
        Restore factory settings
        When the headset is switched on. Press and hold the plus and
        minus keys simultaneously for 8 seconds to restore thefactory
        settings
      `
    },
    
    {
      know_id:2,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'How to reset TOZO OpenReal?',
      description: `
        When the earphones are placed in the charging case, press and hold the charging case button for 8 se
        conds to clear the Bluetooth pairing records and restore the factory settings.
      `
    },
    
    {
      know_id:3,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'How to reset TOZO Open Buds?',
      description: `
      Earbuds (or either one of earbuds) does not pair or connect/ Sound cuts in and out/ Earbuds cannot be found on Bluetooth Search <br/>

      If one of the earphone not work or fail to pair, please reset it: <br/>
      Simultaneously press and hold the touch area and "-" button for 5 seconds. The indicator light will turn <br/>
      off and then flash red and white, that indicating the reset was successful.
      `
    },
    
    {
      know_id:4,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'How to reset TOZO OpenEgo?',
      description: `
      7.0 Reset <br/>
      If you accidentally get only one earbud work, or fail to pair each other, please reset it: <br/>
      When the earphones are powered on and in pairing mode, quickly tap either earphone six times. <br/>
      After the white indicator light blinks rapidly six times, a red light will stay on for 1 second, indicating the
      earphones are powered off. After turning off, the earphones will automatically power on, indicating a
      successful factory reset. <br/>
      Note: In case there is connection unsuccessful in your devices, please delete all historical records of
      [TOZO OpenEgo] and try the paring process again.
      `
    },
    
    {
      know_id:5,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'How to reset TOZO Golden X1?',
      description: `
      1. Place the earbuds into the charging case. <br/>
      2. Press and hold the case button for 15 seconds, then keep the lid is open and wait for 10 seconds 
      before removing the earbuds. <br/>
      NOTE: In case there is [Connection Unsuccessful] in your devices, please delete all historical records of
      [TOZO Golden X1] and try the paring process again.
      `
    },
    
    {
      know_id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      browse: '',
      give: '',
      title: 'How to reset TOZO T6(Classic Edition)?',
      description: `
      (1) Before resetting, delete/forget all TOZO on Bluetooth, and turn off Bluetooth function as well. <br/>
      (2) Press earbuds’ panel for 5 seconds to turn off (red light flashes) the device. <br/>
      (3) Seconds later, touch and hold both earbuds for 5 seconds till red/blue lights flashes simultaneously. Then 
      touch both earbuds three times quickly, once purple light flashes, reset competed. <br/>
      (4) At last, turn on the BT and re-connect.
      `
    },
    
    {
      know_id:7,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      browse: '',
      give: '',
      title: 'How to reset TOZO T6(Classic Edition)?',
      description: `
      (1) Before resetting, delete/forget all TOZO on Bluetooth, and turn off Bluetooth function as well. <br/>
      (2) Press earbuds’ panel for 5 seconds to turn off (red light flashes) the device. <br/>
      (3) Seconds later, touch and hold both earbuds for 5 seconds till red/blue lights flashes simultaneously. Then 
      touch both earbuds three times quickly, once purple light flashes, reset competed. <br/>
      (4) At last, turn on the BT and re-connect.
      `
    },
    
    {
      know_id:8,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      browse: '',
      give: '',
      title: 'How to reset TOZO T9?',
      description: `
      1. Delete all [TOZO-T9] Bluetooth records on your device, and turn off Bluetooth function.  <br/>
      2. Take out both earbuds from the charging case, then press and hold both earbuds for 5 seconds un
      til the white light flashes, the two earbuds will turn off. <br/>
      3. Seconds later, hold and press both earbuds again for 5 seconds, the white light will show up for a
      while. Once the white light disappears, quickly tap the earbuds twice. If only one earbud is flashin
      g frequently, reset is complete. <br/>
      4. Put the earbuds back to the charging case and take them out again, then reconnect them to your 
      device. <br/>
      Note: If your device displays [Connection failed]. Please delete all [TOZO-T9] bluetooth records on all d
      evices before pairing. <br/>
      `
    },
    
    {
      know_id:9,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      browse: '',
      give: '',
      title: 'How to reset TOZO T10 (Classic Edition)?',
      description: `
      (1) Before resetting, delete/forget all TOZO on Bluetooth, and turn off Bluetooth function as well. <br/>
      (2) Press earbuds’ panel for 5 seconds to turn off (red light flashes) the device. <br/>
      (3) Seconds later, touch and hold both earbuds for 5 seconds till red/blue lights flashes simultaneously. Then 
      touch both earbuds twice quickly, once purple light flashes, reset competed. <br/>
      (4) At last, turn on the BT and re-connect. <br/>
      `
    },
    
    {
      know_id:10,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 mini',
      browse: '',
      give: '',
      title: 'How to reset TOZO T10 (Ergonomic with APP Edition(2024))?',
      description: `
      1. Delete all [TOZO T10] Bluetooth records on the phone, then turn off the Bluetooth. <br/>
      2. Pick up two earbuds from charging case, then clicking the both earbuds twice quickly. <br/>
      3. The reset will be done when the blue light flashes rapidly, and then one of the earbuds red and blue light 
      blinking alternately. <br/>
      NOTE: In case there is connection unsuccessful in your devices; please delete all historical records of [TOZO T10] 
      and try the paring process again. <br/>
      `
    },
    
    {
      know_id:11,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      browse: '',
      give: '',
      title: 'How to reset TOZO T12?',
      description: `
      (1) Before resetting, delete/forget all TOZO on Bluetooth, and turn off Bluetooth function as well. <br/>
      (2) Press earbuds’ panel for 5 seconds to turn off (red light flashes) the device. <br/>
      (3) Seconds later, touch and hold both earbuds for 5 seconds till red/blue lights flashes simultaneously. Then 
      touch both earbuds three times quickly, once purple light flashes, reset competed. <br/>
      (4) At last, turn on the BT and re-connect. <br/>
      Please restart the earbuds by taking them from the charging case and connect the [TOZO T12]. <br/>
      `
    },
    
    {
      know_id:12,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      browse: '',
      give: '',
      title: 'How to reset TOZO T12 Pro?',
      description: `
      1. Firstly, please delete/forget both of these [TOZO-T12 Pro] bluetooth records on your phone, then
      turn off the bluetooth. <br/>
      2. Reset each of them separately by the method below. Do not reset them together. <br/>
      (1)Press and hold the touch button of earbud for about 5 seconds until the red light is on for one sec
      ond and turn off. <br/>
      (2)Seconds later, press and hold the touch button of the earbud for 5 seconds. When red/blue lights fl
      ashes simultaneously, quickly tap it for 3 times. <br/>
      (3)When the purple light is flashing for 1 second, the reset process of one earbud will be completed. T
      hen follow this method again to reset another earbud. <br/>
      3. After reset, put them back to the charging case and close the lid. Then take them out of the case, 
      and leave them alone for 30 seconds. <br/>
      4. At last, turn on the bluetooth on your phone and connect [TOZO T12 Pro] again.
      `
    },
    
    {
      know_id:13,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      browse: '',
      give: '',
      title: 'How to reset TOZO T20?',
      description: `
      When earbuds in charging box, long press L & R sensing area for 6 seconds to reset.
      `
    },
    
    {
      know_id:14,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      browse: '',
      give: '',
      title: 'How to reset TOZO T21?',
      description: `
      1. Turn off the bluetooth of the device. Put both of the earbuds into the charging case and close the l
      id for a few seconds. <br/>
      2. Take them out of the charging case, and the white indicator light of the earbuds will blink slowly. T
      hen double click the touch panel on both sides at the same time, and the indicator light will blink swift
      ly for about 3 seconds and then turn to slow blink which shows the resetting complete. Then turn on t
      he bluetooth of the device and connect earbuds again. <br/>
      3. If the fault persists, please perform the preceding steps again. <br/>
      `
    },
    
    {
      know_id:15,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      browse: '',
      give: '',
      title: 'How to reset TOZO NC2?',
      description: `
      If you accidentally get only one earbud work, or fails to pair each other, please reset it: <br/>
      Put earbuds into the charging case, open the lid, press and hold the case button for 15 seconds. <br/>
      NOTE: In case there is [Connection Unsuccessful] in your devices, please delete all historical records of [TOZO-NC2] 
      and try the paring process again. <br/>
      After reset: <br/>
      Open the charging box, keep the earbuds in the charging box, hold the charging box button 3s to force the 
      earbuds to enter into pairing state. Please note that this operation will not clear the previous Bluetooth pairing 
      record. <br/>
      `
    },
    
    {
      know_id:16,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      browse: '',
      give: '',
      title: 'How to reset TOZO NC7?',
      description: `
      1. Delete all [TOZO-NC7] bluetooth records on the phone, then turn off the Bluetooth function. <br/>
      2. Take out both earbuds from the charging case, hold and press the touch button on both earbuds fo
      r 5 seconds until the red light on for one second and turn off. <br/>
      3. Seconds later, hold and press the touch button on both earbuds for 5 seconds. Once the blue light 
      turn on and off, tap the buttons twice quickly, then the two earbuds will flash blue light frequently, an
      d finally the purple light will light up for about a second, indicating that the reset is complete.
      Note: If your device displays [Connection failed]. Please delete all [TOZO-NC7] bluetooth records on all 
      devices before pairing. <br/>
      `
    },
    
    {
      know_id:17,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      browse: '',
      give: '',
      title: 'How to reset TOZO NC9?',
      description: `
      1. Delete all TOZO-NC9 Bluetooth records on the phone, then turn off the Bluetooth. <br/>
      2. Press and hold the touch buttons of both earbuds for about 5 seconds until the red light is on for o
      ne second and turn off. <br/>
      3. Seconds later, press and hold the touch buttons of two earbuds for 5 seconds. When the blue light 
      of the earbud turn on and off, quickly click the both touch buttons for 2 or 3 times. <br/>
      4. When the red light is flashing for 1 second, the reset process will be completed. Then put them bac
      k to the charging case, and take them out again and connect to your device. <br/>
      Note: In case there is [Connection Unsuccessful] in your device, please delete all historical records of 
      [TOZO-NC9] and try the pairing process again. <br/>
      `
    },
    
    {
      know_id:18,
      productId: 'TOZO_NC9_Plus',
      productName: 'TOZO NC9 Plus',
      browse: '',
      give: '',
      title: 'How to reset TOZO NC9 Plus?',
      description: `
      1. Delete all TOZO-NC9 Plus Bluetooth records on the phone, then turn off the Bluetooth. <br/>
      2. Press and hold the touch buttons of both earbuds for about 5 seconds until the red light is on for o
      ne second and turn off. <br/>
      3. Seconds later, press and hold the touch buttons of two earbuds for 5 seconds. When the blue light 
      of the earbud turn on and off, quickly click the both touch buttons for 2 or 3 times. <br/>
      4. When the red light is flashing for 1 second, the reset process will be completed. Then put them bac
      k to the charging case, and take them out again and connect to your device. <br/>
      Note: In case there is [Connection Unsuccessful] in your device, please delete all historical records of 
      [TOZO-NC9 Plus] and try the pairing process again. <br/>
      `
    },
    
    {
      know_id:19,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      browse: '',
      give: '',
      title: 'How to reset TOZO A1?',
      description: `
      1. Remove/forget [TOZO-A1] records on your device, then turn off the bluetooth function. <br/>
      2. Take out both earbuds from the charging case, then quickly tap the both touch buttons 5 times. Re
      set is completed when the red light flashes for one second. <br/>
      3. Put the earbuds back into case first and close the lid. Then take them out again andreconnect to yo
      ur device. <br/>
      Note: If your device displays [Connection failed]. Please delete all [TOZO-A1] bluetooth records on all d
      evices before pairing. <br/>
      `
    },
    
    {
      know_id:20,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      browse: '',
      give: '',
      title: 'How to reset TOZO A2?',
      description: `
      1.Delete all [TOZO-A2] Bluetooth records on your device, then turn off the Bluetooth function. <br/>
      2.Pick up two earbuds from the charging case and wear them, then press and hold both earbuds for a
      bout 5 seconds, and release your fingers after hearing ‘Power off’ <br/>
      3.Press and hold both earbuds again for about 8 seconds, release fingers after hearing ‘PTP pairing’, th
      e reset is complete. <br/>
      4.Put the earbuds into the case and take them out again, the two earbuds will flash red and blue alter
      nately. Turn on the Bluetooth to connect your earbuds. <br/>
      `
    },
    
    {
      know_id:21,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      browse: '',
      give: '',
      title: 'How to reset TOZO A3?',
      description: `
      Put both of earbuds into the charging case, forget/unpair [TOZO- A3] on your device. <br/>
      1.Open the charging case and keep the earbuds in it. <br/>
      2.Hold the charging case button for 8 seconds, the indicator light on the box flash 5 times , and the white light on 
      the earbuds flash fast. <br/>
      3.Take the earbuds out of charging case and connect with device again. <br/>
      `
    },
    
    {
      know_id:22,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      browse: '',
      give: '',
      title: 'How to reset TOZO Crystal Buds?',
      description: `
      (1) Turn off the bluetooth from mobile phone and delete/forget all [TOZO Crystal Buds] bluetooth records. <br/>
      (2) Take earbuds out from the charging case, press the touch panel for 5 seconds to turn the earbuds off. <br/>
      (3) Press and hold both earbuds at the same time for 8 seconds, release them after the white light flashes qu
      ickly. Reset is complete. <br/>
      `
    },
    
    {
      know_id:23,
      productId: 'TOZO_G1',
      productName: 'TOZO G1',
      browse: '',
      give: '',
      title: 'How to reset TOZO G1?',
      description: `
      To restore factory settings, please follow below steps: <br/>
      1. Delete all [TOZO-G1] records on the phone, then turn off the bluetooth function as well. <br/>
      2. Take out the earbuds from the charging case, and quickly tap MFB touch button on both earbuds 5
      times, then the earbuds will turn off. <br/>
      3. Put the earbuds back to charging case and close the lid. Then take the earbuds out again. When th
      e breathing light on one earbud lights up, and the other earbud is flashing, the reset process is comp
      leted. <br/>
      `
    },
    
    {
      know_id:24,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      browse: '',
      give: '',
      title: 'How to reset TOZO H10?',
      description: `
      Restore factory settings
      When the headset is switched on. Press and hold the plus and
      minus keys simultaneously for 8 seconds to restore thefactory
      settings
      `
    },
    
    {
      know_id:25,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      browse: '',
      give: '',
      title: 'The screen does not light up when raising the wrist.',
      description: `
      Check Watch Settings: Ensure that the Raise-to-Wake feature is enabled on the watch. <br/>
      Check App Settings: Confirm that the Raise-to-Wake feature is also enabled in the companion app. <br/>
      Verify Active Time Settings: Ensure the current time is within the active screen-on period set in 
      the app. By default, the screen-on time is set from 8:00 AM to 8:00 PM. If the user needs to adjust this time range, 
      they can do so within the app. <br/>
      `
    },
    
    {
      know_id:26,
      productId: 'Watches',
      productName: 'Watches',
      browse: '',
      give: '',
      title: 'Smartwatch Can Receive Messages but Cannot Make or Receive Calls',
      description: `
      Ensure App Connection: <br/> <br/>

      Verify that the companion app is properly connected to the smartwatch. <br/>
      Check System Bluetooth Settings: <br/> <br/>
      
      Navigate to the Bluetooth settings on your device and enter the device details. If the screen resembles "Figure 2," 
      it indicates that the call-related Bluetooth connection is not established. <br/>
      Tap "Forget This Device" to remove the device from the Bluetooth list. <br/>
      Reconnect Bluetooth via App: <br/> <br/>
      
      Return to the companion app. You should receive a prompt to reconnect Bluetooth. <br/>
      Tap the "Set Up" button, which will automatically take you to the system Bluetooth settings page. Confirm the connection.
      Verify Connection: <br/> <br/>
      
      Re-enter the device details in the Bluetooth settings. If the screen now resembles "Figure 4," the call-related Bluetooth 
      connection is successful. <br/>
      If the connection is not established, repeat the above steps until the screen resembling "Figure 4" appears.
      `
    },
  ]

  //热门说明书资源
  let hot_manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },

    {
      id:3,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:7,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:9,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 User Manual',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 Quick Guide',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    },
  ]

  //热门视频资源
  let hot_VideoTutoralList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    
    {
      id:3,
      productId: 'TOZO_OpenBuds',
      productName: 'TOZO OpenBuds',
      title: 'TOZO Open Buds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:4,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:7,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
  ]

  //自定义的本地数据分页
  function customPaginateData(data, page, perPage) {
    // 确保页数和每页条数是有效的
    page = Math.max(1, page);
    perPage = Math.max(1, perPage);
  
    // 计算总记录数
    const total = data.length;
  
    // 计算总页数
    const lastPage = Math.ceil(total / perPage);
  
    // 计算当前页的开始和结束索引
    const start = (page - 1) * perPage;
    const end = Math.min(start + perPage, total);
  
    // 获取当前页的数据
    const currentPageData = data.slice(start, end);
  
    return {
      current_page: page,
      last_page: lastPage,
      per_page: perPage,
      to: end,
      total: total,
      data: currentPageData
    };
  }